<template>
  <div id="app">
    <header class="mdl-layout__header mdl-layout__header--waterfall">
      <div class="mdl-layout__header-row">
        <div class="mdl-layout__title">PestHelp</div>
        <div class="mdl-layout-spacer"></div>
      </div>
      <navbar></navbar>
    </header>
    <router-view></router-view>
  </div>

</template>

<script>
import Navbar from '@/components/Navbar'

require('material-design-lite')

export default {
  name: 'app',
  components: {
    Navbar
  }
}
</script>

<style <style lang="scss" scoped>

/**
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

html, body {
  font-family: 'Roboto', 'Helvetica', sans-serif;
}

</style>



// WEBPACK FOOTER //
// src/containers/App.vue